import common from '@apps/Common/common.store'

export const isAdmin = () => {
  return !!common.user.super_admin
}
